import utils from '../../Functions/utils';
import HeaderComp from '../Header/Header';
import HomePageComp from '../HomePage/HomePage';
import './Main.css';
import { useState, useEffect } from 'react';
import { HDate } from '@hebcal/core';
import { DayToNum, MonthToNum, ParashaToNum, YearToNum } from '../../Functions/LetterToNum';
import { getFormattedDate, isFullMonth } from '../../Functions/getFormattedDate';
import { useNavigate } from 'react-router-dom';
import { findParentPath } from '../../Functions/findParentPath';


function MainComp(props) {
  const [selectedDay, setSelectedDay] = useState('');
  const [htmlContent, setHtmlContent] = useState('<p>טוען לימוד...</p>');
  const [completedDays, setCompletedDays] = useState([]);
  const [openCategories, setOpenCategories] = useState({});
  const [chabadBooks, setChabadBooks] = useState({});
  const [hebDate, setHebDate] = useState('');
  const [hebDay, setHebDay] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuHeaderOpen, setMenuHeaderOpen] = useState(false);
  const [userData, setuserData] = useState({});
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [fontSize, setFontSize] = useState(16);
  const [showCongrats, setShowCongrats] = useState(false);

  const navigate = useNavigate();

  function convertToHebrewDate() {
    const hDate = new HDate(props.date);
    return hDate.renderGematriya();
  }
  

  // Footnote
  useEffect(() => {
    window.toggleTooltip = function (elem) {
      document.querySelectorAll('.footnoteRef').forEach(ref => {
        if (ref !== elem) ref.classList.remove('active');
      });

      elem.classList.toggle('active');
    };

    const clickHandler = (event) => {
      const isClickInside = event.target.closest('.footnoteRef');
      if (!isClickInside) {
        document.querySelectorAll('.footnoteRef').forEach(ref => {
          ref.classList.remove('active');
        });
      }
    };

    document.addEventListener('click', clickHandler);

    return () => {
      document.removeEventListener('click', clickHandler);
    };
  }, []);


  // GetBooksData
  useEffect(() => {

    // console.log(props.date.getDay() + 1)
    const getBooksData = async () => {
      try {
        let resp = await utils.requestData("GetBooksData", {});

        // console.log(resp[0].jsonValue)
        // console.log(typeof(resp[0]))

        if (resp[0].code !== 90) {
          const rawJsonString = resp[0].jsonValue;
          const cleanJsonString = rawJsonString.replace(/,\s*([}\]])/g, '$1'); // מסיר פסיקים לפני סוגריים
          const dataObj = JSON.parse(cleanJsonString);

        // console.log(dataObj[0].books)
          setChabadBooks(dataObj)
        } else {
          setError(resp[0].msg);
        }

      } catch (error) {
        console.error("Error fetching ChabadBooks:", error);
        setLoading(false);
      }

    };

    getBooksData();

  }, [])

  // userData
  useEffect(() => {

    setHebDate(convertToHebrewDate())

    const getuserData = async () => {
      const localKey = 'userData';

      try {
        const cached = localStorage.getItem(localKey);

        // console.log(cached)
        if (cached) {
          // console.log("01")
          const parsed = JSON.parse(cached);
          setuserData(parsed);
        } else {
          // console.log("02")
          let resp = await utils.requestData("GetUserData", {});

          if (resp[0].code !== 90) {
            setuserData(resp[0]);
            localStorage.setItem(localKey, JSON.stringify(resp[0]));
          } else {
            setError(resp[0].msg);
          }
        }
      } catch (error) {
        console.error("Error fetching userData:", error);
        setLoading(false);
      }
    };

    const convertDayOfToDatePrefix = (dayOf) => {
      if (!/^\d{8}$/.test(dayOf)) return null; 

      const day = dayOf.slice(0, 2);
      const month = dayOf.slice(2, 4);
      const year = dayOf.slice(4);

      return `${year}-${month}-${day}`;
    };
    
    const getCaptureCompleted = async () => {
      try {
        let resp = await utils.requestData("GetUserCompletedChapters", {
          dayOf: getFormattedDate()
        });

        if (resp[0].code !== 90) {
          const parsed = JSON.parse(resp[0].chapterListJson);
          // console.log(parsed)
          if (parsed && parsed.length > 0) {
            const chapterArray = parsed.map(c => ({
              chapterId: c.chapterId,
              dayOf: convertDayOfToDatePrefix(c.dayOf)
            }));

            const uniqueChapters = [...new Set(chapterArray)];
            // console.log(uniqueChapters)

            setCompletedDays(uniqueChapters);
          }
        } else {
          setError(resp[0].msg);
        }

      } catch (error) {
        console.error("Error fetching teamsData:", error);
        setLoading(false);
      }
    };

    getuserData().finally(() => getCaptureCompleted());

  }, [])


  useEffect(() => {
    if(selectedDay == "00108"){
      navigate("/charidy")
    }else{
      fetchHtml(null, null);
    }
  }, [selectedDay]);

  const fetchSelectedChapters = async () => {
    try {
      const resp = await utils.requestData('GetUserFavorites', {});
      return resp.map(x=>x.chapterId);
    } catch (err) {
      console.error('Error fetching selected Chapters:', err);
      return [];
    }
  };

  const fetchHtml = async () => {

  // console.log({ selectedDay, now: new Date().toISOString(), isFinish: false });

    try {

      // chitha
      if (selectedDay == "00101") { // Chumash 
        // console.log("232")
        
        let p = ParashaToNum(props.do);
        // console.log(p)
        // const response = await fetch(`/htmlFiles/chumash/${p}.html`);
        // const html = await response.text();
        const html = await utils.getFile({fileName: `../htmlFiles/chumash/${p}`});
        // console.log(html)
        // const html = await response.text();
        setHtmlContent(html);
        return;
      }

      if (selectedDay === "00102") {
        let d = DayToNum(hebDate.split(" ")[0]); 
        if (d === '29') {
          const fullMonth = isFullMonth();
          if (!fullMonth) {
            d = '2930'; 
          }
        }
        let chapters = await fetchSelectedChapters()
        // console.log(chapters)

        if (chapters.length > 0) {
          const htmlParts = await Promise.all([
            ...chapters.map(x =>
              utils.getFile({ fileName: `../othar_html/tehilim/${x}` })
            ),
            utils.getFile({ fileName: `../htmlFiles/tehilim/${d}` })
          ]);
          
          setHtmlContent(htmlParts.join('<hr />')); 
          return;
        }

        const html = await utils.getFile({ fileName: `../htmlFiles/tehilim/${d}` });
        setHtmlContent(html);
        return;
      }

      if (selectedDay == "00103") { // Tanya 

        let isPshuta = "0"; // Not implemented
        let d = DayToNum(hebDate.split(" ")[0]);
        let m = MonthToNum(hebDate.split(" ")[1].replace("״", ""));
        let y = YearToNum(hebDate.split(" ")[2].replace("״", ""));

        const html = await utils.getFile({fileName: `../htmlFiles/tanya/${isPshuta}/${m}/${d}`});

        setHtmlContent(html);
        return;
      }

      if (selectedDay == "00104") { // Hayomyom 

        let d = DayToNum(hebDate.split(" ")[0]);
        let m = MonthToNum(hebDate.split(" ")[1].replace("״", ""));
        let y = YearToNum(hebDate.split(" ")[2].replace("״", ""));

        const html = await utils.getFile({fileName: `../htmlFiles/Hayomyom/${m}/${d}`});
        setHtmlContent(html);
        return;
      }

      if (selectedDay == "00105") { // Rambam 3 prakim 

        let d = DayToNum(hebDate.split(" ")[0]);
        let m = MonthToNum(hebDate.split(" ")[1].replace("״", ""));
        let y = YearToNum(hebDate.split(" ")[2].replace("״", ""));

        const html = await utils.getFile({fileName: `../htmlFiles/Rambam3/${d}${m}${y}`});
        setHtmlContent(html);
        return;
      }


      if (selectedDay == "00106") { // Rambam perek 1 

        let d = DayToNum(hebDate.split(" ")[0]);
        let m = MonthToNum(hebDate.split(" ")[1].replace("״", ""));
        let y = YearToNum(hebDate.split(" ")[2].replace("״", ""));

        const html = await utils.getFile({fileName: `../htmlFiles/Rambam1/${d}${m}${y}`});
        setHtmlContent(html);
        return;
      }

      
      if (selectedDay == "00107") { // sefer hamitsvot

        let d = DayToNum(hebDate.split(" ")[0]);
        let m = MonthToNum(hebDate.split(" ")[1].replace("״", ""));
        let y = YearToNum(hebDate.split(" ")[2].replace("״", ""));

        const html = await utils.getFile({fileName: `../htmlFiles/seferhamitsvot/${d}${m}${y}`});
        setHtmlContent(html);
        return;
      }
  
      if (selectedDay != "") {
        const html = await utils.getFile({fileName: `../othar_html/${selectedDay}`});
        setHtmlContent(html);
      }

    } catch {
      setHtmlContent('<p style="color:red;">שגיאה בטעינת הקובץ.</p>');
    }
  };

  const toggleCategory = (category) => {
    setOpenCategories((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  const markAsCompleted = () => {
    const updateChapterCompletions = async () => {
      try {
        const userId = localStorage.getItem("userId");
        const alreadyCompleted = completedDays.some(c => c.chapterId === selectedDay);

        await utils.requestData("UpdateChapterCompletions", {
          userId,
          chapterId: selectedDay,
          dayOf: getFormattedDate(),
          isComplete: !alreadyCompleted
        });

        setShowCongrats(true);
        setTimeout(() => {
          setShowCongrats(false)
          setSelectedDay('')
        }, 1500);

        const getCaptureCompleted = async () => {
          try {
            let resp = await utils.requestData("GetUserCompletedChapters", {
              dayOf: getFormattedDate()
            });            
              // console.log(resp[0])

            if (resp[0].code !== 90) {
              const parsed = JSON.parse(resp[0].chapterListJson);
              // console.log(parsed)
              if (parsed.length > 0) {
                const chapterArray = parsed.map(c => ({
                  chapterId: c.chapterId
                  // dayOf: convertDayOfToDatePrefix(c.dayOf)
                }));

                const uniqueChapters = [...new Set(chapterArray)];

                setCompletedDays(uniqueChapters);
              }
            } else {
              setError(resp[0].msg);
            }

          } catch (error) {
            console.error("Error fetching teamsData:", error);
            setLoading(false);
          }
        };
        getCaptureCompleted();

      } catch (error) {
        console.error("Error Update ChapterCompletions:", error);
        setLoading(false);
      }
    };

    updateChapterCompletions();
  };

  const renderDayButtons = (data, path = []) => {
    const order = data.__order || Object.keys(data);

    return order
      .filter((key) => key !== '__order')
      .map((key) => {
        const value = data[key];

        if (typeof value === 'object') {
          // תת קטגוריה
          const fullPath = [...path, key].join(' > ');
          const isOpen = openCategories[fullPath] || false;

          return (
            <div key={fullPath} className="category-block">
              <div onClick={() => toggleCategory(fullPath)} className="category-title">
                <span>{key}</span>
                <span>{isOpen ? '▲' : '▼'}</span>
              </div>
              {isOpen && (
                <div className="buttons-container">
                  {renderDayButtons(value, [...path, key])}<br/>
                </div>
              )}
            </div>
          );
        } else {
          // יום לימוד
          return (
            <button
              key={key}

              className={`day-button ${selectedDay === key ? 'active' : ''} ${completedDays.some(c => c.chapterId === key) ? 'completed' : ''}`}
              onClick={() => {
                // console.log('Clicked key:', key);
                setSelectedDay(key);
                setMenuOpen(false);
              }}
            >
              {value}
            </button>
          );
        }
      });
  };

  const findLabel = (data, dayKey, path = []) => {
    for (const [key, value] of Object.entries(data)) {
      if (typeof value === 'object') {
        const found = findLabel(value, dayKey, [...path, key]);
        if (found) return found;
      } else if (key === dayKey) {
        return [...path, value].join(' - ');
      }
    }
    return null;
  };

  const getSelectedDayLabel = () => {
    return findLabel(chabadBooks, selectedDay) || '';
  };

  


  return (
    <div className="tanya-container">

      <HeaderComp userData={userData} menuHeaderOpen={menuHeaderOpen} setMenuHeaderOpen={setMenuHeaderOpen} />

      <button className="mobile-menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        ☰ קטגוריות
      </button>

      <div className={`day-selector ${menuOpen ? 'open' : ''}`}>
        {renderDayButtons(chabadBooks)}
      </div>        

      {selectedDay !== '' ? (
        <div className="tanya-text">
          <div className="font-size-controls">
            {/* <button className="font-btn" onClick={() => setFontSize(fontSize + 2)}>🤍</button> */}
            <button className="font-btn" onClick={() => setFontSize(fontSize + 2)}>A+</button>
            <button className="font-btn" onClick={() => setFontSize(fontSize - 2)}>A-</button>
            <button className="back-btn" onClick={() => setSelectedDay("")}>חזרה</button>
          </div>

          <h2>{getSelectedDayLabel()}</h2>

          <div className="tanya-content" style={{ fontSize: `${fontSize}px` }} dangerouslySetInnerHTML={{ __html: htmlContent }} />

          {showCongrats && (
            <div className="likes-container">
              {[...Array(7)].map((_, i) => (
                <span key={i} className="like">👍</span>
              ))}
            </div>
          )}


          <button className="mark-completed" onClick={markAsCompleted}>
            {!completedDays.some(c => c.chapterId === selectedDay) ? '✓ למדתי' : 'למד שוב'}
          </button>

          <h5 className="footer-text">לחיזוק ההתקשרות לכ״ק אדמו״ר זיע״א</h5>
        </div>
      ) : (
        <HomePageComp 
          d={props.date} 
          open={(e) => setMenuOpen(e)} 
          menuOpen={menuOpen} 
          selectedDay={(e) => setSelectedDay(e)} 
          sdo={(e)=>{
            props.sdo(e)
            // console.log(e)
            }
          }
        />
      )}
    </div>

  );
}

export default MainComp;
